import * as React from 'react';

import Text from '../../../../text/Text.jsx';

export type SurveyQuestionProps = {
  subline: React.ReactNode;
  children: React.ReactNode;
  hint: React.ReactNode;
};

const SurveyQuestion = ({ subline, children, hint }: SurveyQuestionProps) => (
  <div className="survey-question">
    <Text className="survey-question__subline" variant="headline-4" tag="h3">
      {subline}
    </Text>

    <div className="survey-question__options">{children}</div>

    <Text
      className="survey-question__hint"
      variant="copy"
      modifiers={['bold']}
      tag="div"
    >
      {hint}
    </Text>
  </div>
);

export default SurveyQuestion;
